import {FlowController} from "./FlowController";
import {collapseIframe} from "../../widget/misc/WidgetUtils";
import {Messages} from "../../Messages";
import {PANEL_TYPE} from "../../../blink-sdk/Constants";
import {SubscribeFlowController} from "./SubscribeFlowController";
import {DonateFlowController} from "./DonateFlowController";
import {NewsletterFlowController} from "./NewsletterFlowController";
import {PurchaseFlowController} from "./PurchaseFlowController";
import {IdentityFlowController} from "./IdentityFlowController";

export class CloseController extends FlowController {
    onClick() {
        collapseIframe();
    }

    getActionButtonDefaultLabel() {
        return Messages.close;
    }
}

export class LinkController extends FlowController {
    getActionButtonDefaultLabel() {
        return "";
    }
}

export const PanelTypeToControllerClassMap = {
    [PANEL_TYPE.subscribe]: SubscribeFlowController,
    [PANEL_TYPE.donation]: DonateFlowController,
    [PANEL_TYPE.newsletter]: NewsletterFlowController,
    [PANEL_TYPE.payment]: PurchaseFlowController,
    [PANEL_TYPE.authentication]: IdentityFlowController,
}
